export default __webpack_public_path__ + "static/media/add-to-chromebook.40158389.svg";